const WaitingDots = () => (
  <span className="waiting-dots">
    <span className="dot"></span>
    <span className="dot"></span>
    <span className="dot"></span>
  </span>
);

export default WaitingDots;